import { Popover as Base } from "@base-ui/react/popover";
import type { ReactNode } from "react";

import "./surface.css";
import "./popover.css";
import { cn } from "./cn";

export type PopoverSide = "top" | "bottom" | "left" | "right";
export type PopoverAlign = "start" | "center" | "end";

export interface PopoverContentProps {
  children: ReactNode;
  side?: PopoverSide;
  align?: PopoverAlign;
  sideOffset?: number;
  className?: string;
}

/** Portal + positioned, token-styled popup surface. Focus moves in on open and restores on
 * close; Escape and outside-click dismiss — all from Base UI's headless Popover. */
function PopoverContent({
  children,
  side = "bottom",
  align = "center",
  sideOffset = 8,
  className,
}: PopoverContentProps) {
  return (
    <Base.Portal>
      <Base.Positioner
        className="rc-popover-positioner"
        side={side}
        align={align}
        sideOffset={sideOffset}
      >
        <Base.Popup className={cn("rc-surface", "rc-popover", className)}>
          {children}
        </Base.Popup>
      </Base.Positioner>
    </Base.Portal>
  );
}

/**
 * Token-styled Popover on Base UI's headless primitive. Compound API:
 * `<Popover.Root><Popover.Trigger render={<Button/>} /><Popover.Content>…<Popover.Close/></Popover.Content></Popover.Root>`.
 */
export const Popover = {
  Root: Base.Root,
  Trigger: Base.Trigger,
  Close: Base.Close,
  Content: PopoverContent,
};
